import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ListGroup from "react-bootstrap/ListGroup";
import Header from "../header_h/Header";
import Footer from "../footer/Footer";
import { getAuthorsBySubject } from "../../api/subjects";

const SubjectPage = ({ userName, userRoles }) => {
  const { id, subject } = useParams();

  const [authors, setAuthors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;

    async function load() {
      setLoading(true);
      setError(null);

      try {
        const data = await getAuthorsBySubject(id, subject);
        if (!alive) return;
        setAuthors(Array.isArray(data) ? data : []);
      } catch (e) {
        const status = e?.response?.status;
        const message =
          e?.response?.data?.message ||
          e?.response?.data ||
          e?.message ||
          "Ошибка загрузки";
        if (alive) setError(status ? `${status}: ${message}` : String(message));
        if (alive) setAuthors([]);
      } finally {
        if (alive) setLoading(false);
      }
    }

    load();
    return () => {
      alive = false;
    };
  }, [id, subject]);

  return (
    <>
      <Header userName={userName} userRoles={userRoles} />

      <div className="classContainer">
        {loading && <div>Завантаження...</div>}
        {error && <div style={{ color: "red" }}>{error}</div>}

        {!loading && !error && (
          <ListGroup>
            {authors.length > 0 ? (
              authors.map((a) => (
                <ListGroup.Item
                  key={a.id || `${a.classId}-${a.subjectSlug}-${a.authorSlug}`}
                  action
                  as={Link}
                  to={`/class/${id}/${subject}/${a.authorSlug}/modules`}
                  variant="info"
                  className="list-item"
                >
                  {a.name}
                </ListGroup.Item>
              ))
            ) : (
              <ListGroup.Item className="list-item">Пусто</ListGroup.Item>
            )}
          </ListGroup>
        )}
      </div>

      <Footer />
    </>
  );
};

export default SubjectPage;
